import React from 'react'
import Finalization from './Components/Finalization'

const FinalizationPage = () => {
  return (
    <div>
      <Finalization />
    </div>
  )
}

export default FinalizationPage